<template>
    <span class="switch-toggle" @click="callback">
        <span class="switch-base" :class="{
            checked: checked,
            'alt-colors': altColors,
        }">
            <input type="checkbox" :checked="checked" class="switch-input">
            <span class="switch-thumb"></span>
            <fa-icon :icon="icon" class="switch-icon" v-if="icon" />
        </span>
        <span class="switch-track"></span>
    </span>
</template>

<script>
export default {
    name: 'SwitchToggle',
    props: [
        'icon',
        'checked',
        'callback',
        'altColors',
    ],
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .switch-toggle {
        display: inline-flex;
        width: 60px;
        height: 38px;
        overflow: hidden;
        padding: 12px;
        box-sizing: border-box;
        position: relative;
        flex-shrink: 0;
        z-index: 0;
        vertical-align: middle;

        .switch-base {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
            box-sizing: border-box;
            background-color: transparent;
            color: #1976d2;
            outline: 0;
            border: 0;
            margin: 0;
            border-radius: 0;
            padding: 0;
            cursor: pointer;
            user-select: none;
            vertical-align: middle;
            text-decoration: none;
            color: inherit;
            padding: 9px;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            color: $sage-brown;
            transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

            &.checked {
                transform: translateX(22px);
            }

            &.alt-colors {

                &.checked {
                    color: $green;
                }
            }
        }

        .switch-icon {
            color: white;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: .8em;
        }

        .switch-input {
            cursor: inherit;
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            margin: 0;
            padding: 0;
            z-index: 1;
        }

        .switch-thumb {
            box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2),
                0px 1px 1px 0px rgba(0, 0, 0, .14),
                0px 1px 3px 0px rgba(0, 0, 0, .12);
            background-color: currentColor;
            width: 20px;
            height: 20px;
            border-radius: 50%;
        }

        .switch-track {
            background-color: white;
            box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2),
                0px 1px 1px 0px rgba(0, 0, 0, .14),
                0px 1px 3px 0px rgba(0, 0, 0, .12);
            height: 100%;
            width: 100%;
            border-radius: 7px;
            z-index: -1;
            transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            opacity: 0.5;
            border: 1px solid $sage-brown;
        }
    }
</style>

